import * as React from 'react';
import { Link } from 'react-router';

import PropTypes from 'prop-types';

import Button from 'bundles/internal-ui/components/buttons/Button';

const tabs = [
  {
    link: (userId: $TSFixMe) => '/internal/enterprise/user/' + userId + '/memberships',
    buttonText: 'Program Memberships',
  },
  {
    link: (userId: $TSFixMe) => '/internal/enterprise/user/' + userId + '/curriculum',
    buttonText: 'Curriculum Enrollments',
  },
];

const EnterpriseToolTabs: React.FC<{
  userId: string;
}> = ({ userId }, { router }) => (
  <ul className="enterprise-switcher nav nav-tabs" role="tablist">
    {tabs.map((tab, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={idx} className={router.isActive(tab.link(userId)) && 'active'}>
        <Link
          to={{
            pathname: tab.link(userId),
            query: router.location.query,
          }}
        >
          <Button text={tab.buttonText} btnStyle="link" />
        </Link>
      </li>
    ))}
  </ul>
);

EnterpriseToolTabs.propTypes = {
  userId: PropTypes.string.isRequired,
};

EnterpriseToolTabs.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default EnterpriseToolTabs;
